import apiClient from '@/shared/api/apiClient';
import { AssignSystemToCustomerRequest, AssignSystemToCustomerResponse, Customer, GetCustomerSystemsRequest, GetCustomerSystemsResponse, GetIngestionHistoryResponse, ListCustomersRequest, ListCustomersResponse, ListUnassignedSystemsQuery, ListUnassignedSystemsResponse, SystemCustomerResponse, TriggerIngestionRequest, TriggerIngestionResponse, } from '../domain/customer.types';

const API_BASE_URL = '/customers';

export const customerService = {
  listCustomers: async (request: ListCustomersRequest = {}): Promise<ListCustomersResponse> => {
    const response = await apiClient.get<ListCustomersResponse>(
      `${API_BASE_URL}`,
      {params: request}
    );
    return response.data;
  },

  getCustomerById: async (customerId: string): Promise<Customer> => {
    const response = await apiClient.get<Customer>(
      `${API_BASE_URL}/${customerId}`
    );
    return response.data;
  },

  getCustomerSystems: async (request: GetCustomerSystemsRequest): Promise<GetCustomerSystemsResponse> => {
    const {customerId, ...params} = request;
    const response = await apiClient.get<GetCustomerSystemsResponse>(
      `${API_BASE_URL}/${customerId}/systems`,
      {params}
    );
    return response.data;
  },

  getSystemCustomer: async (systemId: string): Promise<SystemCustomerResponse> => {
    const response = await apiClient.get<SystemCustomerResponse>(
      `${API_BASE_URL}/systems/${systemId}/owner`
    );
    return response.data;
  },

  getIngestionHistory: async (take: number = 10): Promise<GetIngestionHistoryResponse> => {
    const response = await apiClient.get<GetIngestionHistoryResponse>(
      `${API_BASE_URL}/ingestion-history`,
      {params: {take}}
    );
    return response.data;
  },

  triggerExternalDataIngestion: async (request: TriggerIngestionRequest): Promise<TriggerIngestionResponse> => {
    const response = await apiClient.post<TriggerIngestionResponse>(
      `${API_BASE_URL}/trigger-ingestion`,
      request
    );
    return response.data;
  },

  assignSystemToCustomer: async (request: AssignSystemToCustomerRequest): Promise<Array<AssignSystemToCustomerResponse>> => {
    const response = await apiClient.put<Array<AssignSystemToCustomerResponse>>(
      `${API_BASE_URL}/systems/assign`,
      request
    );
    return response.data;
  },

  getUnassignedSystems: async (request: ListUnassignedSystemsQuery = {}): Promise<ListUnassignedSystemsResponse> => {
    const response = await apiClient.get<ListUnassignedSystemsResponse>(
      `${API_BASE_URL}/systems/unassigned`,
      {params: request}
    );
    return response.data;
  },

  toggleFavoriteCustomer: async (customerId: string): Promise<boolean> => {
    const response = await apiClient.post<boolean>(
      `/users/me/favorites/customers/${customerId}/toggle`
    );
    return response.data;
  },
};